import { AtlasApiClient } from '@ag1/atlas-api/client';
import { GetV53WrittenReviewsQuery, GetV53WrittenReviewsResponse } from '@portal/types/review';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeyForV53WrittenReviews } from '../getV53WrittenReviews';

interface MutationProps {
  queries: GetV53WrittenReviewsQuery;
  searchTerm?: string;
  onComplete?: (response: GetV53WrittenReviewsResponse) => void;
  onFail?: (error?: Error) => void;
}

export const useMutationUpdateV53WrittenReviews = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ queries }: MutationProps) => {
      return AtlasApiClient.get('/reviews', { queries });
    },
    onSuccess: (response: GetV53WrittenReviewsResponse, { onComplete }) => {
      queryClient.setQueryData(queryKeyForV53WrittenReviews(), response);
      onComplete?.(response);
    },
    onError: (error: Error, { onFail }: MutationProps) => {
      onFail?.(error);
    }
  });
};
